import { getConfig } from "@/src/config";
import { useState, useRef, useCallback } from "react";
import { Yacht } from "../../Yachts/model";

type SearchPagination = { totalCount: number; page: number; rowsPerPage: number };
export type YachtsData = {
  data: Yacht[];
} & SearchPagination;

export function useOldSearch() {
  const [isSearching, setIsSearching] = useState(false);

  const abortControllerRef = useRef<AbortController | null>(null);

  const performSearch = useCallback(async (query: string) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsSearching(true);
    try {
      const searchUrl = getConfig().SEARCH_URL;

      const url = `${searchUrl}/old-version-search${query}`;

      const response = await fetch(url, {
        mode: "cors",
        signal: abortControllerRef.current.signal,
      });

      const results: YachtsData = await response.json();
      return results;
    } catch (err: any) {
      if (err.name === "AbortError") {
        // expected
        return {} as never;
      }
      throw err;
    } finally {
      setIsSearching(false);
    }
  }, []);

  return { search: performSearch, isSearching };
}

export type Availability = {
  periodStart: string;
  periodEnd: string;
  available: boolean;
  clientPrice: number;
};
export async function fetchAvailability(yId: string): Promise<Availability[]> {
  const searchUrl = getConfig().SEARCH_URL;
  const url = `${searchUrl}/availability/${yId}`;

  const response: Availability[] = await fetch(url, {
    mode: "cors",
  }).then((r) => r.json());

  return response;
}
